import React from 'react';
import PropTypes from 'prop-types';
import { FiAlertTriangle } from 'react-icons/fi';

/** Empty / error card with up to two actions. */
function PackageState({
  icon,
  title,
  message,
  reference,
  primaryText,
  onPrimary,
  secondaryText,
  onSecondary,
}) {
  return (
    <div className="pkg-state" role="status">
      <div className="pkg-state__icon">{icon || <FiAlertTriangle />}</div>
      <h3>{title}</h3>
      {message && <p>{message}</p>}
      {reference && <small className="pkg-state__ref">Ref {reference}</small>}
      {(primaryText || secondaryText) && (
        <div className="pkg-state__actions">
          {primaryText && (
            <button
              type="button"
              className="pkg-state__primary"
              onClick={onPrimary}
            >
              {primaryText}
            </button>
          )}
          {secondaryText && (
            <button
              type="button"
              className="pkg-state__secondary"
              onClick={onSecondary}
            >
              {secondaryText}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

PackageState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  reference: PropTypes.string,
  primaryText: PropTypes.string,
  onPrimary: PropTypes.func,
  secondaryText: PropTypes.string,
  onSecondary: PropTypes.func,
};

PackageState.defaultProps = {
  icon: null,
  message: '',
  reference: '',
  primaryText: '',
  onPrimary: () => {},
  secondaryText: '',
  onSecondary: () => {},
};

export default PackageState;
